import cx from 'classnames';

import s from './Title.module.css';

export const Marked = ({ children }: { children: React.ReactNode }) => {
  return <span className={s.marked}>{children}</span>;
};

export const Title = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return <h2 className={cx(s.title, className)}>{children}</h2>;
};
